export class UploadTimings {
  //
  // Things used by the UploadAnalytics to determine what happened
  //

  get compression() {
    return this._compression;
  }

  compressionDuration() {
    if(!this._compression) { return null; }

    const previousEventTime = this._start;

    return this._compression - previousEventTime;
  }

  completeDuration() {
    return this._complete - this._start;
  }

  // The durations above run from batch start, so they include time spent
  // queued behind other files. These measure only this file's own work.
  // Compression work counts whatever the compressor decided, so time spent on
  // a file that came out not-smaller or errored is still visible.
  compressionWorkDuration() {
    if (!this._compressionStart || !this._compressionEnd) { return null; }

    return this._compressionEnd - this._compressionStart;
  }

  uploadDuration() {
    if (!this._uploadStart || !this._upload) { return null; }

    return this._upload - this._uploadStart;
  }

  //
  // Things used by the uploader, so we can later examine the process
  //

  started() {
    return this._start = this.now();
  }

  compressionStarted() {
    return this._compressionStart = this.now();
  }

  compressionFinished() {
    return this._compressionEnd = this.now();
  }

  compressed() {
    return this._compression = this.now();
  }

  uploadStarted() {
    return this._uploadStart = this.now();
  }

  uploaded() {
    return this._upload = this.now();
  }

  completed(callBack) {
    this._complete = this.now();

    typeof callBack == 'function' && callBack(this);

    return this._complete;
  }

  reset() {
    this._start = null;
    this._compressionStart = null;
    this._compressionEnd = null;
    this._compression = null;
    this._uploadStart = null;
    this._upload = null;
    this._complete = null;  
  }

  //
  // private
  //

  _start = null;            // process begun
  _compressionStart = null; // optionally, this file's compression began
  _compressionEnd = null;   // optionally, the compressor returned (any result)
  _compression = null;      // optionally, compressed the image data
  _uploadStart = null;      // this file's (latest) upload POST began
  _upload = null;           // pushed the image to the storage endpoint (Slingshot)
  _complete = null;         // all subsequent work, e.g. analytics, done

  now() {
    return Date.now();
  }
}

export default UploadTimings;
